import HearClearLeads from "./HearClearLeads";

const CatchmentMining = () => {
  return (
    <div className="catchment-agent" data-testid="catchment-agent">
      <header className="content-header">
        <div>
          <h1>Catchment Mining</h1>
          <p>Crawl the web for contact databases across Delhi NCR — RWA directories, club lists, government employee sheets & more</p>
        </div>
      </header>
      <HearClearLeads />
    </div>
  );
};

export default CatchmentMining;
